import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Image, Row, Col, Card } from 'react-bootstrap';
import { LanguageProvider } from '../core/language-provider';
import { LoginManager } from '../core/login-manager';
import { DataManager } from '../core/data-manager';
import { ResourceManager } from '../core/resource-manager';
import { Helmet } from 'react-helmet';


export default function Categories() {

    const [userInfo, setUserInfo] = useState(null);
    const [data, setData] = useState(null);
    const [errors, setErrors] = useState('');
    const navigate = useNavigate();


    useEffect(() => {
        
        async function init() {
            var u = LoginManager.getUserInfo()
            setUserInfo(u)

            let constraints = []
            var sorting = {
                'field': 'name',
                'order': 'asc'
            }
            var response = await DataManager.searchItems('category', 1, 1000, sorting, '', [], constraints)
            if(response.success === 1) {
                var t = response.body
                setData(t)
                console.warn('categories', t)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
            }
        }

        init()  
    }, []);


    function openCategory(item) {
        navigate('/category/' + item.id)
    }
   


    if (data) {
        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.categories')}</title>
                </Helmet>

                <Container fluid='md' className='mt-5 mb-5 text-secondary'>
                    <h3 className='text-center'>{LanguageProvider.get('header.categories')}</h3>

                    {errors.length > 0 &&
                        <Alert variant='danger'>
                            {errors}
                        </Alert>
                    }

                    {data.length > 0 ? ( 
                        <Row className='mt-5 mb-5'>
                            {data.map((item, j) => {
                                return (
                                    <Col xs={12} md={6} lg={4} key={j}>
                                        <Card role="button" onClick={() => openCategory(item)} className='mt-3 mb-3 text-light category-grid-parent' style={{"backgroundColor": '#eee'}}>
                                            <Card.Body className='category-grid-item'>
                                                <p>
                                                    <b>{item.name}</b>
                                                </p>
                                                <p>
                                                    <span className='small'>
                                                        {item.description && (
                                                            <>
                                                                {item.description.length > 160 ? item.description.substring(0, 160) + '...' : item.description}
                                                            </>
                                                        )}
                                                    </span>
                                                </p>
                                            </Card.Body>
                                        </Card>
                                        
                                    </Col>
                                )
                            })}
                        </Row>
                    ) : (
                        <>
                            <p className='text-center'>Nessuna categoria trovata.</p>
                        </>
                    )}

                </Container>
            </>
        )
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};